let subscribers = new Set();
export const viewManifestReader = {
    value: {},
    subscribe(cb) {
        subscribers.add(cb);
        return () => {
            subscribers.delete(cb);
        };
    },
    set(value) {
        this.value = value;
        subscribers.forEach((cb) => cb(value));
    },
    async preloadAll() {
        await Promise.allSettled(Object.entries(viewManifestReader.value).map(async ([key, value]) => {
            if ("preload" in value && typeof value.preload === "function") {
                await value.preload();
            }
        }));
    },
};
